<div id="top-section"></div>
<app-header class="small-header" (reloadTemplate)="reloadInit()">
</app-header>
<section class="detail-container forMobile bg-fff single-detail-container">
  <div *ngIf="!offers || offers?.data?.length < 1" class="flex align-center justify-center h100 loader-parent">
    <div class="page-loader"></div>
  </div>

  <div *ngIf="offers && offers.data && offers?.data?.length > 0">
    <section class="detail-img-sec relative">
      <div class="details-back flex align-center justify-center z1" (click)="backClicked()"><img src="./assets/img/icons/go-back-left-arrow.png">
      </div>
      <img class="img-fluid detail-img" *ngIf="offers && offers?.data && offers?.data.length > 0"
        loading="lazy" [src]="offers?.data[0]?.attributes?.image_url">
      <div class="img-overlay absolute h100 w100"></div>
    </section>
  </div>

  <section class="bor-t relative" *ngIf="offers && offers.data && offers?.data?.length > 0">

    <div class="multi-sec-2">
      <section class="heading-sec flex align-center">
        <div class="modal-mer-logo">
          <img class="img-fluid object-fit" loading="lazy" [src]="offers?.data?.merchant?.logo_url">
        </div>
        <h2 class="no-margin cfff fnt-20 f600">{{offers?.data?.merchant?.name}}</h2>
      </section>
    </div>

    <div class="offers-parent pad-15 multi-sec-4 single-j">
      <div>
        <div class="offer-nav flex mar-top-22" *ngIf="offers?.data?.length > 1">
          <div class="offer-btn cfff fnt-12 flex align-center justify-center  active"
            [ngClass]="{'active' : openedOffer == i}" *ngFor="let offer of offers?.data; let i = index"
            (click)="openedOffer = i">Offer {{ i + 1}}</div>
        </div>
        <div *ngFor="let offer of offers?.data; let i = index">
          <div class="offers-single pad-15 pad-bot-0 mar-top-20" *ngIf="openedOffer == i">
            <div class="single-offer-title fnt-18 pad-bot-15 f500"
              [ngStyle]="{'color': GlobalConstants.data.colors.offer_title_color}">{{offer?.attributes?.title}}</div>
            <div class="disabled-txt" *ngIf = "isDisabled">*This offer is temporarily not available. Please check back in some time.</div>
            <div class="c-555 multi-d">
              <div class="multi-d-in">
                <div [innerHtml]="offer?.attributes?.description" class="fnt-14 cACB2BA desc"></div>
              </div>
            </div>
            <div>
              <svg width="32" height="1" viewBox="0 0 32 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="1" fill="#474F5A" />
              </svg>
            </div>
            <div class="valid-till flex space-between">
              <div class="flex">
                <div class="val-icon">
                  <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M13.3333 1.7H12.5V0H10.8333V1.7H4.16667V0H2.5V1.7H1.66667C0.741667 1.7 0.00833333 2.465 0.00833333 3.4L0 15.3C0 16.235 0.741667 17 1.66667 17H13.3333C14.25 17 15 16.235 15 15.3V3.4C15 2.465 14.25 1.7 13.3333 1.7ZM13.3333 15.3H1.66667V6.8H13.3333V15.3ZM13.3333 5.1H1.66667V3.4H13.3333V5.1ZM7.5 9.35H11.6667V13.6H7.5V9.35Z"
                      fill="#3F3D3D" />
                  </svg>
                </div>
                <div class="v-lbl c3F3D3D fnt-12 pad-top-1 mar-bot-23">Validity - <b
                    class="f600">{{offer?.attributes?.end_date | date: 'mediumDate'}}</b></div>
              </div>
            </div>
            <div class="bot-btns flex align-center space-between mar-top-15 bg-fff fnt-12 c3F3D3D f500"
              (click)="selectOffer(offer,offers?.data?.merchant);sideMenuOpen = true;openedInSlide = 'terms'">
              <span>Terms & conditions</span>
              <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 5L0.5 9.33013V0.669873L5 5Z" fill="#3F3D3D" />
              </svg>
            </div>
            <div class="bot-btns flex align-center space-between mar-top-15 bg-fff fnt-12 c3F3D3D f500 last-bot-btns"
              (click)="selectOffer(offer,offers?.data?.merchant);sideMenuOpen = true;openedInSlide = 'about'">
              <span>About {{offers?.data?.merchant?.name}}</span>
              <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 5L0.5 9.33013V0.669873L5 5Z" fill="#3F3D3D" />
              </svg>
            </div>
            <div class="single-off-btn" [class.resend-btn] = "authenticated_user && offer?.attributes?.eligible && !offer?.attributes?.claimable">
              <div *ngIf="authenticated_user" class="w100">
                <div *ngIf="GlobalConstants.data.personalized_config.auth">
                  <div *ngIf="offer?.attributes?.eligible && offer?.attributes?.claimable">
                    <button class="ga-click btn gen-c-btn fnt-16 w100" [disabled] = "isDisabled"
                      (click)="selectOffer(offer);redeemOffer(offer)"
                      [ngStyle]="{'background': GlobalConstants.data.colors.mainBtn_color}">Claim Offer</button>
                  </div>
                  <div *ngIf="offer?.attributes?.eligible && !offer?.attributes?.claimable && isTimesPrime" class="d-flex flex-column align-items-center">
                    <div class="voucher-box flex mar-bot-10 w-100 flex-column">
                      <div *ngIf="vouchers[offer?.id]?.code" class="code-box flex space-between align-center fnt-13 relative"
                        [ngStyle]="{'border-color': GlobalConstants.data.colors.mainBtn_color}">
                        <div class="absolute gv-lbl fnt-10 pad-left-3 pad-right-3">COUPON CODE</div>
                        <span>{{vouchers[offer?.id]?.code}}</span> <svg class="pointer" width="14" height="16" viewBox="0 0 14 16"
                          fill="none" xmlns="http://www.w3.org/2000/svg" (click)="copy(vouchers[offer?.id]?.code)">
                          <path [ngStyle]="{'fill': GlobalConstants.data.colors.mainBtn_color}"
                            d="M10.3158 0H1.47368C0.663158 0 0 0.654545 0 1.45455V11.6364H1.47368V1.45455H10.3158V0ZM9.57895 2.90909H4.42105C3.61053 2.90909 2.95474 3.56364 2.95474 4.36364L2.94737 14.5455C2.94737 15.3455 3.60316 16 4.41368 16H12.5263C13.3368 16 14 15.3455 14 14.5455V7.27273L9.57895 2.90909ZM4.42105 14.5455V4.36364H8.8421V8H12.5263V14.5455H4.42105Z" />
                        </svg>
                      </div>
                      <a (click)="goTo(offer)"
                      target="_blank" rel="noreferrer noopener" class="btn gen-c-btn fnt-18 w100 pointer d-flex align-items-center justify-content-center claim-btn w-100 mt-2"
                      [ngStyle]="{'background': GlobalConstants.data.colors.mainBtn_color}">Redeem</a>
                    </div>
                    <!-- <button class="btn gen-c-btn fnt-18 w100 pointer d-flex align-items-center justify-content-center claim-btn mx-auto" (click)="goTo(offer)">Redeem</button> -->
                  </div>
                  <div *ngIf="offer?.attributes?.eligible && !offer?.attributes?.claimable && !isTimesPrime">
                    <button class="btn gen-c-btn fnt-16 w100 inactive-btn capitalize cursor-default">
                      <span>Claimed</span>
                    </button>
                      <div class="text-center pad-top-5 pad-bot-5 f500">
                        <span *ngIf = "resendText === 'Voucher Resent'" class="fnt-12">{{resendText}}</span>
                        <span *ngIf = "resendText !== 'Voucher Resent'" class="fnt-12 pointer" [class.underline] = "resendText === 'Resend Voucher'" (click) = "resendCode(offer.id)">{{resendText}}</span>
                      </div>
                  </div>
    
                  <div *ngIf="!offer?.attributes?.eligible">
                    <button class="btn gen-c-btn fnt-16 w100 inactive-btn capitalize cursor-default">
                      <span>Not eligible</span>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="!authenticated_user" class="w100">
                <button class="ga-click btn gen-c-btn fnt-16 w100" [disabled] = "isDisabled"
                  *ngIf="GlobalConstants.data.personalized_config.authenticate_before_claim"
                  (click)="redeemOffer(offer)"
                  [ngStyle]="{'background': GlobalConstants.data.colors.mainBtn_color}">Claim Offer</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="slide-menu-content" [class]="sideMenuOpen ? 'slide-menu-content open' : 'slide-menu-content'"
    *ngIf="selectedOffer">
    <div class="close-btn flex justify-end">
      <div (click)="sideMenuOpen = false">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 1.20857L10.7914 0L6 4.79143L1.20857 0L0 1.20857L4.79143 6L0 10.7914L1.20857 12L6 7.20857L10.7914 12L12 10.7914L7.20857 6L12 1.20857Z"
            fill="#B7BECB" />
        </svg>
      </div>
    </div>
    <div class="no-margin li-margin-bottom-12">
      <section class="heading-sec flex align-center modal-head-sec">
        <div class="merchant-logo">
          <img class="img-fluid object-fit" loading="lazy" [src]="selectedOffer?.merchant?.logo_url">
        </div>
        <h2 class="no-margin c0E202E fnt-20">{{selectedOffer?.merchant?.name}}</h2>
      </section>
      <div class="desc-sec pad-top-7 pad-bot-5" *ngIf="openedInSlide == 'about'">
        <div [innerHTML]="selectedOffer?.merchant?.description" class="no-last-p c3A4149 fnt-12"></div>
      </div>
      <div class="term-sec" *ngIf="openedInSlide == 'terms'">
        <h4 class="mar-bot-15 c0E202E fnt-14">Terms & Conditions</h4>
        <div [innerHTML]="selectedOffer?.attributes?.terms" class="no-last-p c3A4149 fnt-12"></div>
      </div>
    </div>
  </div>
</section>

<section class=" for-desktop">
  <div class="container pad-top-40 pad-bot-40 desktop-mid">
    <div class="offer-details flex">
      <div class=" col-md-3 no-padding">
        <div [class]="!is_loading ? 'row d-none' : 'row'">
          <div class="col-sm-12">
            <div class="timeline-wrapper">
              <div class="timeline-item">
                <div class="animated-background">
                  <div class="background-masker content-top"></div>
                  <div class="background-masker content-second-line"></div>
                  <div class="background-masker content-third-line"></div>
                  <div class="vertical-bottom lf"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="det-left pad-bot-15" *ngIf="!is_loading && offers?.data">
          <div class="offer-det-img">
            <img alt="" class="img-fluid" loading="lazy" [src]="offers?.data[0]?.attributes?.image_url">
          </div>
          <div class="merchant-title mar-top-20 fnt-20 f500">About {{offers?.data?.merchant?.name}}</div>
          <div class="mar-bot-30" id="desc-1">
            <div class="to-show merchant-desc mar-top-10 fnt-13 c98A2B4"
              [innerHtml]="offers?.data?.merchant?.description"
              [ngStyle]="{'max-height':merchantDescOpen ?  'inherit' : '80px' }"></div>
            <div class="more-desc flex flex-end"
              *ngIf="offers?.data?.merchant?.description && checkLength(offers?.data?.merchant?.description) > 170">
              <span class="f500 fnt-12 pointer">
                <span class="s-more" (click)="merchantDescOpen = !merchantDescOpen"
                  [ngStyle]="{'color': GlobalConstants.data.colors.mainBtn_color}">
                  <span *ngIf="!merchantDescOpen">Show More</span>
                  <span *ngIf="merchantDescOpen">Show Less</span>
                </span>
              </span>
            </div>
          </div>
          <div class="visit-merchant-btn">
            <a href="{{offers?.data?.merchant?.website}}" target="_blank" rel="noreferrer noopener" class="ga-to-merchant f500 btn btn-light">Go
              to website</a>
          </div>
        </div>
      </div>
      <div class="offer-det col-md-9 no-padding ng-star-inserted">
        <div [class]="!is_loading ? 'row d-none' : 'row'">
          <div class="col-sm-12">
            <div class="timeline-wrapper merchant-loader">
              <div class="timeline-item">
                <div class="animated-background">
                  <div class="background-masker l1"></div>
                  <div class="background-masker l2"></div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="merchant-name-logo flex align-center mar-bot-20" *ngIf="!is_loading && offers?.data">
          <div class="mer-l"><img loading="lazy" [src]="offers?.data?.merchant?.logo_url" class="img-fluid"></div>
          <div class="mer-title c3A4149 f500 fnt-26">{{offers?.data?.merchant?.name}}</div>
        </div>
        <div [class]="!is_loading ? 'row d-none' : 'row'">
          <div class="col-sm-12">
            <div class="timeline-wrapper offer-loader">
              <div class="timeline-item">
                <div class="animated-background">
                  <div class="background-masker w100 rf1"></div>

                  <div class="background-masker content-third-line"></div>
                  <div class="vertical-bottom"></div>
                  <div class="vertical-1"></div>
                  <div class="vertical-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section *ngIf="!is_loading">
          <ng-container *ngFor="let offer of offers?.data; let i = index">
            <div class="single-offer-disp no-margin bg-fff"
              *ngIf="!GlobalConstants.data.personalized_config.details_desktop_tabs || (GlobalConstants.data.personalized_config.details_desktop_tabs && openedOffer == i)">
              <div class="flex single-inside">
                <div class="col-md-8">
                  <h3 class="offer-title fnt-18 mar-bot-15"
                    [ngStyle]="{'color': GlobalConstants.data.colors.active_text_color}">{{offer?.attributes?.title}}</h3>
                  <div class="disabled-txt fnt-15 pad-bot-10" *ngIf = "isDisabled">*This offer is temporarily not available. Please check back in some time.</div>
                  <p class="offer-desc fnt-14 c3A4149" [innerHtml]="offer?.attributes?.description"></p>
                </div>
                <div class="col-md-4">
                  <div class="offer-coupon-code  mar-bot-20 flex justify-end">
                    <div>
                      <div *ngIf="authenticated_user">
                        <div >
                          <div *ngIf="offer?.attributes?.eligible && offer?.attributes?.claimable">
                            <button class="ga-click btn gen-c-btn fnt-18 w100 claim-btn"
                              (click)="redeemOffer(offer);showCouponPop = true" [disabled] = "isDisabled">Claim Offer</button>
                          </div>
                          <div *ngIf="offer?.attributes?.eligible && !offer?.attributes?.claimable">
                            <div *ngIf="isTimesPrime" class="d-flex flex-column voucher-box mar-bot-10">
                              <div *ngIf="vouchers[offer?.id]?.code" class="code-box flex space-between align-center fnt-13 relative"
                                [ngStyle]="{'border-color': GlobalConstants.data.colors.mainBtn_color}">
                                <div class="absolute gv-lbl fnt-10 pad-left-3 pad-right-3">COUPON CODE</div>
                                <span>{{vouchers[offer?.id]?.code}}</span> <svg class="pointer" width="14" height="16" viewBox="0 0 14 16"
                                  fill="none" xmlns="http://www.w3.org/2000/svg" (click)="copy(vouchers[offer?.id]?.code)">
                                  <path [ngStyle]="{'fill': GlobalConstants.data.colors.mainBtn_color}"
                                    d="M10.3158 0H1.47368C0.663158 0 0 0.654545 0 1.45455V11.6364H1.47368V1.45455H10.3158V0ZM9.57895 2.90909H4.42105C3.61053 2.90909 2.95474 3.56364 2.95474 4.36364L2.94737 14.5455C2.94737 15.3455 3.60316 16 4.41368 16H12.5263C13.3368 16 14 15.3455 14 14.5455V7.27273L9.57895 2.90909ZM4.42105 14.5455V4.36364H8.8421V8H12.5263V14.5455H4.42105Z" />
                                </svg>
                              </div>
                              <a (click)="goTo(offer)"
                                target="_blank" rel="noreferrer noopener" class="btn gen-c-btn fnt-18 w100 pointer d-flex align-items-center justify-content-center claim-btn w-100 mt-2"
                                [ngStyle]="{'background': GlobalConstants.data.colors.mainBtn_color}">Redeem</a>
                              <!-- <button class="btn gen-c-btn fnt-18 w100 pointer d-flex align-items-center justify-content-center claim-btn mx-auto" (click)="goTo(offer)">Redeem</button> -->
                              <!-- <div class="mt-2 fnt-12 d-flex c-777 align-items-center justify-content-end">
                                Valid Till: <div class="fnt-13 c-555 ml-1"> {{ vouchers[offer?.id]?.voucher_end_date | date: 'mediumDate'}} </div>
                              </div> -->
                            </div>
                            <ng-container *ngIf="!isTimesPrime">
                              <button class="btn gen-c-btn fnt-18 w100 inactive-btn cursor-default">Claimed</button>
                              <div class="text-center pad-top-8">
                                <span *ngIf = "resendText === 'Voucher Resent'" class="fnt-13">{{resendText}}</span>
                                <span *ngIf = "resendText !== 'Voucher Resent'" class="fnt-13 pointer" [class.underline] = "resendText === 'Resend Voucher'" (click) = "resendCode(offer.id)">{{resendText}}</span>
                              </div>  
                            </ng-container>
                          </div>
                          <div *ngIf="!offer?.attributes?.eligible">
                            <button class="btn gen-c-btn fnt-18 w100 inactive-btn cursor-default">Not eligible</button>
                          </div>
                        </div>

                      </div>
                      <div *ngIf="!authenticated_user">
                        <button class="ga-click btn gen-c-btn fnt-18 w100 claim-btn" [disabled] = "isDisabled"
                          *ngIf="GlobalConstants.data.personalized_config.authenticate_before_claim"
                          (click)="redeemOffer(offer)"
                          >Claim Offer</button>
                      </div>
                      <div *ngIf="!GlobalConstants.data.personalized_config.auth">
                        <button class="ga-click btn gen-c-btn fnt-18 w100 claim-btn" [disabled] = "isDisabled"
                          [ngStyle]="{'background': GlobalConstants.data.colors.mainBtn_color}"
                          (click)="selectOffer(offer);redeemCardCheck(offer);">Claim Offer</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class=" offer-below-row-parent  fnt-15">
                <div class="flex offer-below-row w100 mar-top-10">
                  <div class="col-md-6 no-padding-right c3A4149  flex align-center offer-below-lft">
                    <svg width="15" height="18" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                      class="icons">
                      <path
                        d="M19.5556 2.4H18.3333V0H15.8889V2.4H6.11111V0H3.66667V2.4H2.44444C1.08778 2.4 0.0122222 3.48 0.0122222 4.8L0 21.6C0 22.92 1.08778 24 2.44444 24H19.5556C20.9 24 22 22.92 22 21.6V4.8C22 3.48 20.9 2.4 19.5556 2.4ZM19.5556 21.6H2.44444V9.6H19.5556V21.6ZM19.5556 7.2H2.44444V4.8H19.5556V7.2ZM11 13.2H17.1111V19.2H11V13.2Z"
                        fill="#565A5E" />
                    </svg>
                    <span>Valid till: </span>
                    <b> {{offer?.attributes?.end_date | date: 'mediumDate'}}</b>
                  </div>
                  <div class="col-md-6  text-right no-padding-left terms-block">
                    <span class="pointer hover-underline" (click)="selectOffer(offer);openModal(redeemModal);">Terms &
                      Conditions</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </section>
      </div>
    </div>

  </div>
  <ng-template #redeemModal id="redeemModal">
    <div class="coupon-modal-header flex justify-end pad-15 pad-bot-0">
      <svg class="pointer modal-close-svg" (click)="modalRef.hide()" width="15" height="15" viewBox="0 0 15 15"
        fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z"
          fill="#919aa2" />
      </svg>
    </div>
    <div class="modal-body text-left coupon-modal-body pad-left-40 pad-right-40" [class.redeem-click]="redeemActive">
      <section class="">
        <div class=" no-margin terms-contain">
          <p class="offer-desc no-margin fnt-16 f600">{{selectedOffer?.attributes?.title}}</p>

          <div class="term-sec mar-top-20">

            <div [innerHTML]="selectedOffer?.attributes.terms"></div>
          </div>
        </div>
      </section>
      <section class="terms-btns pad-top-20 pad-bot-10 flex align-center justify-center hide">
        <button (click)="goTo(selectedOffer);modalRef.hide();" class="btn fnt-13 accept pad-20 pad-top-7 pad-bot-7"
          [ngStyle]="{'background': GlobalConstants.data.colors.mainBtn_color}">Accept & Continue</button>
        <button (click)="modalRef.hide(); redeemActive = false" class="btn fnt-13 cancel pad-20 pad-top-7 pad-bot-7"
          [ngStyle]="{'color': GlobalConstants.data.colors.mainBtn_color}">Cancel</button>
      </section>
    </div>
  </ng-template>


</section>
